import { Injectable, OnDestroy } from "@angular/core";
import _ from "lodash";
import { Subject } from "rxjs";
import { tap } from "rxjs/operators";

/** @deprecated */
export enum PAGES_NAME {
  ORDER_DETAIL_GUEST = 0,
  GUEST_DETAIL = 1,
  GUEST_SIMILAR = 2,
  ORDER_DETAIL_BASIC = 3,
  HOUR_ORDER_DETAIL_BASIC = 4,
  CREATE_ORDER = 5,
}

/** @deprecated */
interface Node<T> {
  next: Node<T> | null;
  pre: Node<T> | null;
  element: T;
}
/** @deprecated */
export interface JumpData {
  page: PAGES_NAME;
  code?: string; // 入住单号
  id?: number | string; // 房客ID
  tab?: number;
  showBack?: boolean;
  refresh?: boolean;
}
/** @deprecated */
class LianBiao<T> {
  length = 0;
  head: Node<T> | null = null;
  rear: Node<T> | null = null;
  append(element: Node<T>) {
    const node: Node<T> = element;
    if (this.head === null) {
      this.head = node;
      this.rear = node;
    } else {
      let current = this.head;
      while (current.next) {
        current = current.next;
      }
      current.next = node;
      node.pre = current;
      this.rear = node;
    }
    this.length++;
  }
}
/** @deprecated */
class LianBiaoNode<T> implements Node<T> {
  element: T;
  next: Node<T> | null = null;
  pre: Node<T> | null = null;
  constructor(
    element: T,
    Linext: Node<T> | null = null,
    Lipre: Node<T> | null = null
  ) {
    this.element = element;
    this.next = Linext;
    this.pre = Lipre;
  }
}

export enum PageName {
  GuestList = 'GuestList',
  GuestDetail = 'GuestDetail',
  GuestSimilar = 'GuestSimilar',
  OrderDetail = 'OrderDetail',
  HourOrderDetail = 'HourOrderDetail',
  RateDetail = 'RateDetail',
}

export interface Page {
  name: PageName;
  payload?: any;
}

/** @TODO @FIXME 该模块放置全局通用服务，不涉及业务逻辑。此服务需放置到具体业务模块下 */

@Injectable({
  providedIn: "root",
})
export class SwitchPageService implements OnDestroy {
  /** @deprecated */
  biao = new LianBiao<JumpData>();
  /** @deprecated */
  currentNodeRaw$ = new Subject<JumpData>();
  /** @deprecated */
  currentNode: LianBiaoNode<JumpData>;


  pages: Page[] = [];
  switchPageRaw$ = new Subject<Page>();

  // switchPage$ = this.switchPageRaw$.pipe(
  //   tap(page => {
  //     if (!page) {
  //       this.pages = [];
  //       return;
  //     }

  //     // if (!this.isActive(page.name)) {
  //     //   this.pushState(page);
  //     // } else {
  //     //   this.replaceState(page);
  //     // }
  //     console.log('after navigate: pages: ', JSON.parse(JSON.stringify(this.pages)));
  //   })
  // );

  constructor() {
    // this.switchPage$.subscribe();
  }

  navigate (name: PageName, payload?: any) {
    console.log('================================================================')
    console.log('before navigate: pages: ', JSON.parse(JSON.stringify(this.pages)));
    const page = { name, payload };

    if (!this.isActive(name)) {
      this.pushState(page);
    } else {
      this.replaceState(page);
    }

    const current = _.last(this.pages);
    console.log('switch page: ', current);
    this.switchPage(current);
    console.log('after navigate: pages: ', JSON.parse(JSON.stringify(this.pages)));
  }

  back () {
    console.log('back: pages: ', JSON.parse(JSON.stringify(this.pages)));
    this.pages.pop();

    const pre = this.pages.pop();
    if (pre) {
      this.navigate(pre.name, pre.payload);
    }
  }

  go (step: number) {
    switch (step) {
      case -1: this.back(); break;
      case 0: this.pages = []; this.switchPage(null); break;
    }
  }

  private switchPage(page: Page) {
    this.switchPageRaw$.next(page);
  };

  private pushState (page: Page) {
    this.pages.push(page);
  }

  private replaceState (page: Page) {
    const current = this.pages.pop();
    // current.payload = { ...current.payload, ...page.payload };
    _.merge(current.payload, page.payload);

    this.pages.push(current);
  }

  private isActive (name: PageName) {
    const current = _.last(this.pages);
    return _.get(current, 'name') === name;
  }

  // --------------------------------

  /**  @deprecated 初始化链表 */
  initOrderLianBiao(params: {
    page: number;
    code?: string;
    tab?: number;
    showBack?: boolean;
    id?: number;
  }) {
    const node = new LianBiaoNode<JumpData>({
      page: params.page,
      code: params.code,
      tab: params.tab,
      showBack: params.showBack,
      id: params.id,
    });
    this.biao.append(node);
  }

  // 插入节点,往前打开页面就是插入节点的过程，且在队尾添加
  /** @deprecated */
  insertNode(params: {
    page: PAGES_NAME;
    tab?: number;
    id?: number;
    showBack: boolean;
    code?: string;
  }) {
    const info = {
      page: params.page,
      id: params.id,
      tab: params.tab,
      code: params.code,
      showBack: params.showBack,
    };
    const node = new LianBiaoNode<JumpData>(info);
    this.biao.append(node);
  }

  // 删除节点，往回退，就是删除节点的过程，且在队尾删除
  /** @deprecated */
  deleteNode() {
    if (this.biao.length === 0) {
      return;
    }
    const currentNode = this.biao.rear;
    this.biao.rear = currentNode.pre;
    currentNode.pre = null;
    currentNode.next = null;
    _.assign(this.biao.rear, {
      next: null,
    });
    this.biao.length--;
  }

  // 销毁链表
  /** @deprecated */
  destroyLianBiao() {
    this.biao = new LianBiao<JumpData>();
  }

  // 获取当前节点信息
  /** @deprecated */
  updateCurrentNode(value?) {
    this.currentNodeRaw$.next(value === null ? null : this.biao.rear.element);
    this.currentNode = value === null ? null : this.biao.rear;
  }

  /** 以下为业务逻辑接口 */

  // 新建链表
  /** @deprecated */
  createNewLianBiao(params: {
    page: number;
    code?: string;
    tab?: number;
    showBack?: boolean;
    id?: number;
  }) {
    this.destroyLianBiao();
    this.initOrderLianBiao(params);
    this.updateCurrentNode();
  }

  // 销毁当前链表
  /** @deprecated */
  destroyCurrentLianBiao() {
    this.destroyLianBiao();
    this.updateCurrentNode(null);
  }

  // 删除当前节点并更新
  /** @deprecated */
  deleteNodeAndUpdateCurrentNode(refresh?) {
    this.deleteNode();
    if (refresh) {
      _.assign(this.biao.rear.element, {
        refresh: true,
      });
      if (this.biao.length === 1) {
        this.biao.head = this.biao.rear;
      }
    } else {
      _.assign(this.biao.rear.element, {
        refresh: false,
      });
    }

    this.updateCurrentNode();
  }

  // 插入当前节点并更新
  /** @deprecated */
  insertNodeAndUpdateCurrentNode(params: {
    page: PAGES_NAME;
    tab?: number;
    id: number;
    showBack: boolean;
    code?: string;
  }) {
    this.insertNode(params);
    this.updateCurrentNode();
  }

  // 替换尾节点：即删除、插入、更新
  /** @deprecated */
  changeRear(params: {
    page: PAGES_NAME;
    tab: number;
    id?: number;
    showBack: boolean;
    code?: string;
  }) {
    this.deleteNode();
    this.insertNode(params);
    this.updateCurrentNode();
  }

  ngOnDestroy() {
    this.currentNodeRaw$.complete();
  }
}
